export default __webpack_public_path__ + "static/media/helmet3.a495a4d4.png";